import styled from '@emotion/styled'

export const FooterWrapper = styled.footer`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 60px;
  margin-top: auto;
  padding: 0 32px;
`

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1152px;
  font-size: 14px;
`

export const FooterLink = styled.a`
  margin: 0 4px;
`
